import { render, staticRenderFns } from "./shelf-panter-project.pug?vue&type=template&id=76df98c9&lang=pug&"
import script from "./shelf-panter-project.ts?vue&type=script&lang=ts&"
export * from "./shelf-panter-project.ts?vue&type=script&lang=ts&"
import style0 from "./shelf-panter-project.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports